import { render, staticRenderFns } from "./TrialCourseSetting.vue?vue&type=template&id=809c386c&scoped=true&"
import script from "./TrialCourseSetting.vue?vue&type=script&lang=js&"
export * from "./TrialCourseSetting.vue?vue&type=script&lang=js&"
import style0 from "./TrialCourseSetting.vue?vue&type=style&index=0&id=809c386c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809c386c",
  null
  
)

export default component.exports